import { loadStripe } from '@stripe/stripe-js';

export default async (context, inject) => {
  if (!context.$stripe) {
    const stripe = await loadStripe(process.env.STRIPE_PUBLISHABLE_KEY);
    inject('stripe', stripe);
  }
};
